import { NoteEditorWebComponent } from './component/NoteEditorWebComponent';
import { WEB_COMPONENT_NOTE_EDITOR } from '../../webcomponents.constants';

export { NoteEditorWebComponent };

window.customElements.define(WEB_COMPONENT_NOTE_EDITOR, NoteEditorWebComponent);
